/* eslint-disable global-require */
/* eslint-disable import/no-dynamic-require */
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import App from './App.vue';

const locales = process.env.VUE_APP_TENANTS.split(',');
const buildConfig = require('../public/buildConfig');

Vue.use(VueI18n);

const copy = {};
locales.forEach(tenant => {
    copy[`${buildConfig[tenant].culture}`] = {
        content: require(`../public/global404/content/${buildConfig[tenant].culture}.json`)
    };
});

const AppData = App.data();

const i18n = new VueI18n({
    locale: AppData.locale,
    messages: copy
});

Vue.config.productionTip = false;

new Vue({
    render: h => h(App),
    i18n
}).$mount('.pageNotFoundContainer');
